import * as React from 'react';
import { useState, useEffect } from 'react';
import CircularProgress from '@mui/material/CircularProgress'
import Stack from '@mui/material/Stack';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContentText from '@mui/material/DialogContentText';
import { LinkLicense, getAllCompanyValue, getAllHardwareModels, GetLicenses } from '../../services/service';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import TextField from '@mui/material/TextField';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};


export default function EditHardwareModelModal(props) {
  const [loading, setLoading] = useState(false);
  const [statusField, setStatusField] = useState('');
  const { hardwareModel, show, onClose } = props

  const [allCompany, setAllcompany] = useState([])
  const [allHardwareModels, setAllHardwareModels] = useState([])

  const [licenseData, setLicenseData] = useState([])
  const [hardwareData, setHardwareData] = useState([])
  const [LicenseSelected, SetLicenseSelected] = useState([])

  useEffect(() => {
    getAllCompanyValue().then((resp) => setAllcompany(resp.data.results))

  }, [getAllCompanyValue])

  useEffect(() => {
    getAllHardwareModels().then((resp) => setAllHardwareModels(resp.data.results))

  }, [getAllHardwareModels])

  useEffect(() => {
    GetLicenses().then((resp) => {
      console.log(resp.data.results)
      setLicenseData(resp.data.results)
    })
  }, [GetLicenses])

  useEffect(() => {
    setHardwareData(hardwareModel)
  }, [hardwareModel])

  const linkRequest = () => {
    LinkLicense(hardwareModel.hardware_key, LicenseSelected)
    var data = {
      hardware_key: hardwareModel.hardware_key,
      license: LicenseSelected.value,
    }
    LinkLicense(data)
  }

  const handleChangeLicense = (e) => {
    SetLicenseSelected(e.target)
  }
  return (
    <Stack spacing={2} direction="row">

      <Modal
        open={show}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} style={{ borderStyle: 'hidden', minWidth: '35rem', borderRadius: '0.5rem' }}>
          <DialogTitle id="responsive-dialog-title">
            <h4>Vincular Hardware </h4>
          </DialogTitle>
          <Row>
            <Col>
              <DialogContent>
                <DialogContentText>
                  <FormControl variant="standard" sx={{ m: 2, minWidth: 120 }}>
                    <TextField
                      //id = name is buging the textfield
                      id="name"
                      label="Hardware Key"
                      disabled={true}
                      value={hardwareModel.hardware_key}
                      variant="outlined"
                      size="small"
                      error={!!statusField['name']}
                      helperText={!!statusField['name'] ? statusField['name'][0].message : null}
                    />
                  </FormControl>
                  <FormControl variant="standard" sx={{ m: 2, minWidth: 120 }}>
                    <InputLabel id="demo-simple-select-standard-label">Licenças Disponíveis</InputLabel>
                    <Select
                      labelId="demo-simple-select-standard-label"
                      id="demo-simple-select-standard"
                      onChange={handleChangeLicense}
                      label="Name"
                    >
                      <MenuItem value="">
                        <em>Todas</em>
                      </MenuItem>
                      {licenseData.map((e) => !e.is_linked ?
                        <MenuItem value={e.license_type.id}>{e.license_type.name}</MenuItem> : null
                      )}
                    </Select>
                  </FormControl>
                </DialogContentText>
              </DialogContent>
            </Col>
          </Row>

          <DialogActions>
            <Button onClick={onClose}
              style={{ right: '1.5rem' }}>
              Fechar
            </Button>
            <Button
              disabled={loading}
              onClick={() => linkRequest()}
              variant="contained"
              style={{ right: '1rem' }}>
              {loading ? <CircularProgress /> : 'Vincular'}
            </Button>
          </DialogActions>
        </Box>
      </Modal>
    </Stack>

  );
}